import { getClassNameFromSectionModelUtil } from 'models/utils/get-class-name-from-section'
import { getEndpointFromSectionModelUtil } from 'models/utils/get-endpoint-from-section'
import { getAliasCategoriesSelector } from 'modules/categories/selectors'
import { loadLegacyReduxAction } from 'modules/redux/actions/legacy/load'
import REDUX_OPTION from 'modules/redux/constants/option'
import getDefaultDomainListPathFromPath from 'modules/redux/utils/get-default-domain-list-path-from-domain-path'
import getDomainPathFromSectionReduxUtil from 'modules/redux/utils/get-domain-path-from-section'
import {
  getEndpointSectionUtil,
  getInstancesSectionUtil
} from 'modules/section/utils'
import {
  SECTIONS_ITEMS_COUNT_PER_PAGE,
  SECTIONS_OPTION
} from 'modules/sections/constants/index.cjs'
import {
  getObjectUtil,
  logUtil
} from 'packages/src'
import getByQueryPathReduxUtil from 'modules/redux/utils/getByQueryPath/index.js'

/**
 * Loads a collection.
 * @param  {Object} route
 * @param  {Object} [match]
 * @param  {Object} [options={}]
 *         {Object} options.params
 *         {Object} options.location
 *         {boolean} options[SECTIONS_OPTION.NEXT_PAGE]
 *         {boolean} options[SECTIONS_OPTION.QUERY]
 * @returns {Function}
 */
export default function loadSectionAction (route, match, options = {}) {
  return async (dispatch, getState) => {
    const debugProps = {
      route,
      match
    }
    logUtil('loadSectionAction').debug('[start] debugProp=', debugProps)

    if (!route) {
      logUtil('loadSectionAction').warn('[noop] no route found debugProps=', debugProps)
      return
    }

    // Get the section
    const { section } = route
    const query = options.query || {}

    // Get the Domain
    const path = getDomainPathFromSectionReduxUtil(section)
    const domain = getState()[path]

    // If the category exists, gets its alias
    let category = getObjectUtil(match, 'params.category')
    if (category) {
      category = getAliasCategoriesSelector(section, category)(getState())
    }

    // Get the items in the Domain or SubDomain
    const items = getInstancesSectionUtil({
      category,
      domain,
      section
    })

    const itemsCount = items.length
    let page = Math.round(
      itemsCount / SECTIONS_ITEMS_COUNT_PER_PAGE
    )

    if (
      options[REDUX_OPTION.MIN_BATCH_SIZE] &&
      itemsCount >= options[REDUX_OPTION.MIN_BATCH_SIZE] &&
      !options[REDUX_OPTION.FORCED]
    ) {
      return
    }

    // If it's a next page, load it
    if (options[SECTIONS_OPTION.NEXT_PAGE]) {
      page += 1
    } else if (
      itemsCount >= SECTIONS_ITEMS_COUNT_PER_PAGE &&
      !(query.query || query.q)
    ) {
      // If it's not a next page and there are enough items in the section
      // and it's not a search, noop
      return
    }

    // so the `DomainList` is updated as expected
    options[REDUX_OPTION.OMIT_SUCCESS_STATUS_BATCH_SIZE] = SECTIONS_ITEMS_COUNT_PER_PAGE
    // TODO make this pagination better
    options[REDUX_OPTION.FORCED] = true
    // If a category is specified, it will be used as a `DomainList`
    let domainListPath
    const q = query.query || query.q

    if (category && !options?.isFromSearchPage) {
      domainListPath = `${path}.${category}`
    } else if (q) {
      domainListPath = getByQueryPathReduxUtil(path, q)
    } else {
      domainListPath = getDefaultDomainListPathFromPath(path)
    }

    let remoteUrl
    if (route.isApp) {
      remoteUrl = TRAINING_API_ENDPOINT
    } else {
      remoteUrl = API_ENDPOINT
    }

    // Get the endpoint with the given parameters
    const endpoint = getEndpointSectionUtil({
      category,
      endpoint: getEndpointFromSectionModelUtil(section),
      page,
      query
    })

    logUtil('loadSectionAction').debug('domainListPath=', domainListPath)

    await dispatch(
      loadLegacyReduxAction({
        endpoint,
        path,
        className: getClassNameFromSectionModelUtil(section),
        options,
        domainListPath,
        remoteUrl
      })
    )
  }
}
